import { createSelector } from 'reselect';

// used internaly in getFilteredActiveComponentId in components bundle
// pt should always get activeComponent there (components bundle)
export const getActiveComponentId = (state) => state.application.activeComponentId;

export const getZoomComponentId = (state) => state.application.zoomComponentId;

export const getActiveModelId = (state) => state.application.activeModelId;

export const getViewerReady = (state) => state.application.viewerReady;

export const getPollingInterval = (state) => state.application.pollingInterval;

export const getPollingDateRange = createSelector(
  (state) => state.application.pollingDateRanges,
  (_, panelId) => panelId,
  (pollingDateRanges, panelId) => pollingDateRanges[panelId] || pollingDateRanges.global
);

export const getTimezone = (state) => state.application.timezone;

export const getActiveComponentFilter = (state) => state.application.activeComponentFilter;

export const getLastRefresh = (state) => state.application.refreshedAt;

export const getPollingActive = createSelector(
  [(state) => state.application.isPollingActive, (_, slice) => slice],
  (isPollingActive, slice) => {
    if (slice) {
      return !!isPollingActive[slice];
    }
    return Object.values(isPollingActive).some((part) => !!part);
  }
);

export const getPageType = (state) => state.application.pageType;
